export default "__VITE_ASSET__BNbJKsFt__"